import { themeToVars, type Theme } from './tokens';

/**
 * Apply a theme to the document.
 *
 * Tokens go on <html> as inline custom properties. Inline styles sit above
 * every stylesheet rule, so they beat the :root defaults in index.css without
 * needing !important or a class swap.
 *
 * Safe to call before React mounts and on every subsequent change.
 */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;

  for (const [cssVar, value] of Object.entries(themeToVars(theme))) {
    root.style.setProperty(cssVar, value);
  }

  // `mode` drives anything that keys off light/dark at the CSS level rather
  // than off a token: native form controls via color-scheme, and the few
  // rules (shadows, monogram tints) that need a different recipe on dark.
  root.style.setProperty('color-scheme', theme.mode);
  root.classList.toggle('dark', theme.mode === 'dark');
  root.dataset.theme = theme.id;
  root.dataset.themeMode = theme.mode;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) {
    meta.content = theme.chromeColor;
  }
}
